import { CONTACT } from "../data/site";

export const WhatsAppButton = () => {
  const number = CONTACT.phoneRaw.replace("+", "");
  const msg = encodeURIComponent("Merhaba, GES kurulumu hakkında bilgi almak istiyorum.");
  const href = `https://wa.me/${number}?text=${msg}`;

  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-float-button"
      aria-label="WhatsApp ile yaz"
      className="fixed bottom-6 right-6 z-[60] group flex items-center gap-3"
    >
      <span className="hidden sm:block max-w-0 overflow-hidden group-hover:max-w-[200px] transition-all duration-500 whitespace-nowrap bg-black/80 backdrop-blur border border-white/10 text-white text-sm px-0 group-hover:px-4 py-2.5 rounded-full">
        WhatsApp'tan Yaz
      </span>
      <span className="relative flex items-center justify-center w-14 h-14 rounded-full bg-[#25D366] shadow-lg shadow-[#25D366]/30 hover:scale-105 active:scale-95 transition-transform duration-200">
        <span className="absolute inset-0 rounded-full bg-[#25D366] animate-ping opacity-20" />
        <svg viewBox="0 0 32 32" className="w-7 h-7 fill-white relative z-10">
          <path d="M16.003 3C9.383 3 4 8.383 4 15.003c0 2.117.553 4.176 1.6 5.994L4 29l8.2-1.55a11.94 11.94 0 0 0 3.803.62h.001C22.62 28.07 28 22.687 28 16.067 28 9.447 22.62 3 16.003 3zm7.03 16.86c-.293.822-1.72 1.573-2.37 1.67-.606.09-1.373.128-2.216-.14-.51-.162-1.166-.378-2.006-.74-3.53-1.525-5.834-5.08-6.01-5.315-.176-.234-1.438-1.912-1.438-3.648 0-1.736.91-2.59 1.234-2.943.323-.353.705-.44.94-.44.234 0 .47.002.675.012.216.01.506-.082.79.603.293.705 1 2.44 1.087 2.616.088.176.147.383.03.617-.117.235-.176.382-.352.588-.176.206-.37.46-.53.617-.176.176-.36.367-.155.72.206.353.916 1.51 1.966 2.446 1.35 1.203 2.49 1.575 2.843 1.75.353.176.558.147.764-.088.206-.235.882-1.03 1.117-1.383.235-.353.47-.294.79-.176.323.117 2.05.968 2.402 1.144.353.176.588.264.675.412.088.146.088.85-.205 1.672z"/>
        </svg>
      </span>
    </a>
  );
};
